import { RANDOM_THOUGHTS } from './randomThoughts';
import { RANT } from './rant';
import { WHAT_IS_THIS_PAGE } from './whatsThis';

export const INITIAL_PAGES = [RANT, WHAT_IS_THIS_PAGE, RANDOM_THOUGHTS];
